export const VALID_RENDERING_DETAILS_TYPE = {
    DISPLAY: "DISPLAY",
    SEPARATOR: "SEPARATOR",
    BUTTON: "BUTTON",
    TOOLTIPDISPLAY: "TOOLTIPDISPLAY",
    TITLE: "TITLE",
    INFODISPLAY: "INFODISPLAY",
    TRANSPARENT_SEPARATOR: "TRANSPARENT_SEPARATOR",
    BILL_DETAILS_SECTION_END: "BILL_DETAILS_SECTION_END",
};

export const RENDERING_DETAILS_TYPES = {
    GRAND_TOTAL: "GRAND_TOTAL",
    ADD_DELIVERY_TIP: "ADD_DELIVERY_TIP",
    ITEM_TOTAL: "ITEM_TOTAL",
    TAXES_AND_CHARGES: "TAXES_AND_CHARGES",
    OFFER_CASH_REWARD: "OFFERCASHREWARD",
    QUICK_MODE_FEE: "QUICK_MODE_FEE",
};
